const msdbq_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth: "F[0].Page_1[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup: "F[0].Page_1[0].RadioButtonList[2]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    radioGroup: "F[0].Page_1[0].RadioButtonList[1]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "Please identify the evidence reviewed and the date range",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Evidence reviewed",
      number: "0",
    },
    maxLength: 2000,
    presidence: "Yes",
    radioGroup: "F[0].Page_1[0].RadioButtonList[3]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName: "F[0].Page_1[0].IdentifyEvidence[0]",
    textanswer: "",
  },

  {
    question:
      "Does ##name## have any pharynx and/or larynx and/or swallowing conditions due to multiple sclerosis?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "2",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3B",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].#subform[1].Yes3[0]",
    dbqName_no: "F[0].#subform[1].No3[0]",
    answer: "",
  },
  {
    question:
      "Pharynx and/or Larynx and/or swallowing conditions due to multiple sclerosis",
    sub: "Check all that apply",
    type: "radioTiles",
    refId: 1,
    show: false,
    multi: true,
    small: true,
    cols: 2,
    section: {
      page: "2",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3B",
    },
    questions: [
      {
        main: "Constant inability to communicate by speech",
        dbqName: "F[0].#subform[1].B1[0]",
        answer: "",
      },
      {
        main: "Speech not intelligible or individual is aphonic (loss of voice)",
        dbqName: "F[0].#subform[1].B2[0]",
        answer: "",
      },
      {
        main: "Paralysis of soft palate with swallowing difficulty (nasal regurgitation) and speech impairment",
        dbqName: "F[0].#subform[1].B3[0]",
        answer: "",
      },
      {
        main: "Hoarseness",
        dbqName: "F[0].#subform[1].B4[0]",
        answer: "",
      },
      {
        main: "Mild swallowing difficulties",
        dbqName: "F[0].#subform[1].B5[0]",
        answer: "",
      },
      {
        main: "Moderate swallowing difficulties",
        dbqName: "F[0].#subform[1].B6[0]",
        answer: "",
      },
      {
        main: "Severe swallowing difficulties, permitting passage of liquids only",
        dbqName: "F[0].#subform[1].B7[0]",
        answer: "",
      },
      {
        main: "Requires feeding tube due to swallowing difficulties",
        dbqName: "F[0].#subform[1].B8[0]",
        answer: "",
      },
      // {
      //    "main":"Other",
      //    "dbqName":"F[0].#subform[1].B9[0]",
      //    "answer":"",
      //    "textarea": true,
      //    "maxLength": 670,
      //    "textdbqName" : "F[0].#subform[1].DescribeOther[0]",
      //    "placeholder": "Please describe",
      //    "textAnswer": ""
      // }
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## have sleep disturbances attributable to multiple sclerosis?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "2",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3D",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].#subform[1].Yes5[0]",
    dbqName_no: "F[0].#subform[1].No5[0]",
    answer: "",
  },
  {
    question: "Sleep disturbances attributable to multiple sclerosis",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    cols: 2,
    section: {
      page: "2",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3D",
    },
    questions: [
      {
        main: "Insomnia",
        dbqName: "F[0].#subform[1].D1[0]",
        answer: "",
      },
      {
        main: "Hypersomnolence and/or daytime 'sleep attacks'",
        dbqName: "F[0].#subform[1].D2[0]",
        answer: "",
      },
      {
        main: "Persistent daytime hypersomnolence",
        dbqName: "F[0].#subform[1].D3[0]",
        answer: "",
      },
      {
        main: "Sleep apnea requiring the use of a CPAP machine",
        dbqName: "F[0].#subform[1].D4[0]",
        answer: "",
      },
      {
        main: "Sleep apnea causing chronic respiratory failure with carbon dioxide retention or cor pulmonale",
        dbqName: "F[0].#subform[1].D5[0]",
        answer: "",
      },
      {
        main: "Sleep apnea requiring tracheostomy",
        dbqName: "F[0].#subform[1].D6[0]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## have any bowel functional impairment attributable to multiple sclerosis?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3E",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_2[0].Yes6[0]",
    dbqName_no: "F[0].Page_2[0].No6[0]",
    answer: "",
  },
  {
    question: "Bowel functional impairment attributable to multiple sclerosis?",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    cols: 2,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3E",
    },
    questions: [
      {
        main: "Slight impairment of sphincter control, without leakage",
        dbqName: "F[0].Page_2[0].E1[0]",
        answer: "",
      },
      {
        main: "Constant slight leakage",
        dbqName: "F[0].Page_2[0].E2[0]",
        answer: "",
      },
      {
        main: "Occasional moderate leakage",
        dbqName: "F[0].Page_2[0].E21[0]",
        answer: "",
      },
      {
        main: "Occasional involuntary bowel movements, necessitating wearing of a pad",
        dbqName: "F[0].Page_2[0].E3[0]",
        answer: "",
      },
      {
        main: "Extensive leakage and fairly frequent involuntary bowel movements",
        dbqName: "F[0].Page_2[0].E4[0]",
        answer: "",
      },
      {
        main: "Total loss of bowel sphincter control",
        dbqName: "F[0].Page_2[0].E5[0]",
        answer: "",
      },
      {
        main: "Chronic constipation",
        dbqName: "F[0].Page_2[0].E6[0]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## have voiding dysfunction causing urine leakage attributable to multiple sclerosis?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3F",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_2[0].Yes7[0]",
    dbqName_no: "F[0].Page_2[0].No7[0]",
    answer: "",
  },
  {
    question:
      "Voiding dysfunction causing urine leakage attributable to multiple sclerosis?",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3F",
    },
    questions: [
      {
        main: "Does not require the use of absorbent material (Bedliners, diapers, etc)",
        dbqName: "F[0].Page_2[0].F1[0]",
        answer: "",
      },
      {
        main: "Requires absorbent material that is changed less than 2 times per day",
        dbqName: "F[0].Page_2[0].F2[0]",
        answer: "",
      },
      {
        main: "Requires absorbent material that is changed 2 to 4 times per day",
        dbqName: "F[0].Page_2[0].F3[0]",
        answer: "",
      },
      {
        main: "Requires absorbent material that is changed more than 4 times per day",
        dbqName: "F[0].Page_2[0].F4[0]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## have voiding dysfunction causing urinary frequency attributable to multiple sclerosis?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3G",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_2[0].Yes8[0]",
    dbqName_no: "F[0].Page_2[0].No8[0]",
    answer: "",
  },
  {
    question:
      "Voiding dysfunction causing urinary frequency attributable to multiple sclerosis?",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    cols: 2,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3G",
    },
    questions: [
      {
        main: "Daytime voiding interval between 2 and 3 hours",
        dbqName: "F[0].Page_2[0].G1[0]",
        answer: "",
      },
      {
        main: "Nighttime awakening to void 2 times",
        dbqName: "F[0].Page_2[0].G4[0]",
        answer: "",
      },
      {
        main: "Daytime voiding interval between 1 and 2 hours",
        dbqName: "F[0].Page_2[0].G2[0]",
        answer: "",
      },
      {
        main: "Nighttime awakening to void 3 to 4 times",
        dbqName: "F[0].Page_2[0].G5[0]",
        answer: "",
      },
      {
        main: "Daytime voiding interval less than 1 hour",
        dbqName: "F[0].Page_2[0].G3[0]",
        answer: "",
      },
      {
        main: "Nighttime awakening to void 5 or more times",
        dbqName: "F[0].Page_2[0].G6[0]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question:
      "Does ##name## have voiding dysfunction requiring the use of an appliance attributable to multiple sclerosis?",
    sub: "Please identify the evidence reviewed and the date range",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3I",
    },
    maxLength: 2000,
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_2[0].Yes12[1]",
    dbqName_no: "F[0].Page_2[0].No12[1]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please describe",
    textdbqName: "F[0].Page_2[0].Describe[0]",
    textanswer: "",
  },

  {
    question:
      "Does ##name## have a history of recurrent symptomatic urinary tract infections attributable to MS? ",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "4",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3J",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_3[0].Yes13[0]",
    dbqName_no: "F[0].Page_3[0].No13[0]",
    answer: "",
  },
  {
    question:
      "History of recurrent symptomatic urinary tract infections attributable to MS",
    sub: "",
    type: "radioModal",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    cols: 2,

    section: {
      page: "4",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3J",
    },
    questions: [
      {
        main: "No treatment",
        dbqName: "F[0].Page_3[0].I1[0]",
        answer: "",
      },
      {
        main: "Long-term drug therapy",
        dbqName: "F[0].Page_3[0].I2[0]",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_3[0].DescribeOther[0]",
        placeholder1:
          "Please list the medication and indicate dates for courses of treatment over the past 12 months",
      },
      {
        main: "Hospitalization",
        dbqName: "F[0].Page_3[0].I3[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "1 or 2 per year",
            dbqName: "F[0].Page_3[0].One[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "More than 2 per year",
            dbqName: "F[0].Page_3[0].Two[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Frequency of hospitalization",
      },
    ],
  },

  {
    question: "Does ##name## have Erectile Dysfunction attributable to MS?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,

    section: {
      page: "4",
      title: "CONDITIONS, SIGNS AND SYMPTOMS DUE TO MS",
      number: "3K",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_3[0].Yes14[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_3[0].Yes16[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_3[0].No16[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is the Veteran able to achieve an erection (without medication) sufficient for penetration and ejaculation?",
      },
      {
        main: "No",
        dbqName: "F[0].Page_3[0].No14[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_3[0].Yes17[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_3[0].No17[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is the Veteran able to achieve an erection (with medication) sufficient for penetration and ejaculation?",
      },
    ],
  },

  {
    question: "Does ##name##'s Gait (walking/stride) abnormal due to MS?",
    sub: "If gait is abnormal, identify the conditions and describe each condition",
    type: "yesno",
    show: true,
    section: {
      page: "4",
      title: "NEUROLOGIC EXAM",
      number: "4A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_3[0].Abnormal[0]",
    dbqName_no: "F[0].Page_3[0].Normal[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please describe",
    textdbqName: "F[0].Page_3[0].Describe[0]",
    textanswer: "",
  },
  {
    question:
      "Rate ##name##'s muscle strength according to the following scale ",
    sub: "",
    type: "select",
    show: true,
    section: {
      page: "5",
      title: "NEUROLOGIC EXAM",
      number: "4B",
    },
    questions: [
      {
        label: "Flexion/Extension",
        title: "Right Side",
        subMain: "Rate Strength",
        sub: "",
        options: [
          {
            main: "Shoulder Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ShoulderExtenR_0[0],F[0].Page_4[0].ShoulderExtenR_1[0],F[0].Page_4[0].ShoulderExtenR_2[0],F[0].Page_4[0].ShoulderExtenR_3[0],F[0].Page_4[0].ShoulderExtenR_4[0],F[0].Page_4[0].ShoulderExtenR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Shoulder Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ShoulderFlexR_0[0],F[0].Page_4[0].ShoulderFlexR_1[0],F[0].Page_4[0].ShoulderFlexR_2[0],F[0].Page_4[0].ShoulderFlexR_3[0],F[0].Page_4[0].ShoulderFlexR_4[0],F[0].Page_4[0].ShoulderFlexR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Elbow Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ElbowFlexionR_0[0],F[0].Page_4[0].ElbowFlexionR_1[0],F[0].Page_4[0].ElbowFlexionR_2[0],F[0].Page_4[0].ElbowFlexionR_3[0],F[0].Page_4[0].ElbowFlexionR_4[0],F[0].Page_4[0].ElbowFlexionR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Elbow Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ElbowExtensionR_0[0],F[0].Page_4[0].ElbowExtensionR_1[0],F[0].Page_4[0].ElbowExtensionR_2[0],F[0].Page_4[0].ElbowExtensionR_3[0],F[0].Page_4[0].ElbowExtensionR_4[0],F[0].Page_4[0].ElbowExtensionR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Wrist Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].WristFlexionR_0[0],F[0].Page_4[0].WristFlexionR_1[0],F[0].Page_4[0].WristFlexionR_2[0],F[0].Page_4[0].WristFlexionR_3[0],F[0].Page_4[0].WristFlexionR_4[0],F[0].Page_4[0].WristFlexionR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Wrist Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].WristExtensionR_0[0],F[0].Page_4[0].WristExtensionR_1[0],F[0].Page_4[0].WristExtensionR_2[0],F[0].Page_4[0].WristExtensionR_3[0],F[0].Page_4[0].WristExtensionR_4[0],F[0].Page_4[0].WristExtensionR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Grip",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].GripR_0[0],F[0].Page_4[0].GripR_1[0],F[0].Page_4[0].GripR_2[0],F[0].Page_4[0].GripR_3[0],F[0].Page_4[0].GripR_4[0],F[0].Page_4[0].GripR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Pinch (thumb to index finger)",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].PinchR_0[0],F[0].Page_4[0].PinchR_1[0],F[0].Page_4[0].PinchR_2[0],F[0].Page_4[0].PinchR_3[0],F[0].Page_4[0].PinchR_4[0],F[0].Page_4[0].PinchR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Hip Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].HipExtenR_0[0],F[0].Page_4[0].HipExtenR_1[0],F[0].Page_4[0].HipExtenR_2[0],F[0].Page_4[0].HipExtenR_3[0],F[0].Page_4[0].HipExtenR_4[0],F[0].Page_4[0].HipExtenR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Hip Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].HipFlexR_0[0],F[0].Page_4[0].HipFlexR_1[0],F[0].Page_4[0].HipFlexR_2[0],F[0].Page_4[0].HipFlexR_3[0],F[0].Page_4[0].HipFlexR_4[0],F[0].Page_4[0].HipFlexR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Knee Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].KneeR_0[0],F[0].Page_4[0].KneeR_1[0],F[0].Page_4[0].KneeR_2[0],F[0].Page_4[0].KneeR_3[0],F[0].Page_4[0].KneeR_4[0],F[0].Page_4[0].KneeR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Ankle Plantar Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].PlantarR_0[0],F[0].Page_4[0].PlantarR_1[0],F[0].Page_4[0].PlantarR_2[0],F[0].Page_4[0].PlantarR_3[0],F[0].Page_4[0].PlantarR_4[0],F[0].Page_4[0].PlantarR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Ankle Dorsiflexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].AnkleR_0[0],F[0].Page_4[0].AnkleR_1[0],F[0].Page_4[0].AnkleR_2[0],F[0].Page_4[0].AnkleR_3[0],F[0].Page_4[0].AnkleR_4[0],F[0].Page_4[0].AnkleR_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
        ],
      },
      {
        label: "Flexion/Extension",
        title: "Left Side",
        subMain: "Rate Strength",
        sub: "",
        options: [
          {
            main: "Shoulder Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ShoulderExtenL_0[0],F[0].Page_4[0].ShoulderExtenL_1[0],F[0].Page_4[0].ShoulderExtenL_2[0],F[0].Page_4[0].ShoulderExtenL_3[0],F[0].Page_4[0].ShoulderExtenL_4[0],F[0].Page_4[0].ShoulderExtenL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Shoulder Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ShoulderFlexL_0[0],F[0].Page_4[0].ShoulderFlexL_1[0],F[0].Page_4[0].ShoulderFlexL_2[0],F[0].Page_4[0].ShoulderFlexL_3[0],F[0].Page_4[0].ShoulderFlexL_4[0],F[0].Page_4[0].ShoulderFlexL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Elbow Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ElbowFlexionL_0[0],F[0].Page_4[0].ElbowFlexionL_1[0],F[0].Page_4[0].ElbowFlexionL_2[0],F[0].Page_4[0].ElbowFlexionL_3[0],F[0].Page_4[0].ElbowFlexionL_4[0],F[0].Page_4[0].ElbowFlexionL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Elbow Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].ElbowExtensionL_0[0],F[0].Page_4[0].ElbowExtensionL_1[0],F[0].Page_4[0].ElbowExtensionL_2[0],F[0].Page_4[0].ElbowExtensionL_3[0],F[0].Page_4[0].ElbowExtensionL_4[0],F[0].Page_4[0].ElbowExtensionL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Wrist Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].WristFlexionL_0[0],F[0].Page_4[0].WristFlexionL_1[0],F[0].Page_4[0].WristFlexionL_2[0],F[0].Page_4[0].WristFlexionL_3[0],F[0].Page_4[0].WristFlexionL_4[0],F[0].Page_4[0].WristFlexionL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Wrist Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].WristExtensionL_0[0],F[0].Page_4[0].WristExtensionL_1[0],F[0].Page_4[0].WristExtensionL_2[0],F[0].Page_4[0].WristExtensionL_3[0],F[0].Page_4[0].WristExtensionL_4[0],F[0].Page_4[0].WristExtensionL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Grip",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].GripL_0[0],F[0].Page_4[0].GripL_1[0],F[0].Page_4[0].GripL_2[0],F[0].Page_4[0].GripL_3[0],F[0].Page_4[0].GripL_4[0],F[0].Page_4[0].GripL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Pinch (thumb to index finger)",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].PinchL_0[0],F[0].Page_4[0].PinchL_1[0],F[0].Page_4[0].PinchL_2[0],F[0].Page_4[0].PinchL_3[0],F[0].Page_4[0].PinchL_4[0],F[0].Page_4[0].PinchL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Hin Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].HipExtenL_0[0],F[0].Page_4[0].HipExtenL_1[0],F[0].Page_4[0].HipExtenL_2[0],F[0].Page_4[0].HipExtenL_3[0],F[0].Page_4[0].HipExtenL_4[0],F[0].Page_4[0].HipExtenL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Hip Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].HipFlexL_0[0],F[0].Page_4[0].HipFlexL_1[0],F[0].Page_4[0].HipFlexL_2[0],F[0].Page_4[0].HipFlexL_3[0],F[0].Page_4[0].HipFlexL_4[0],F[0].Page_4[0].HipFlexL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Knee Extension",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].KneeL_0[0],F[0].Page_4[0].KneeL_1[0],F[0].Page_4[0].KneeL_2[0],F[0].Page_4[0].KneeL_3[0],F[0].Page_4[0].KneeL_4[0],F[0].Page_4[0].KneeL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Ankle Plantar Flexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].PlantarL_0[0],F[0].Page_4[0].PlantarL_1[0],F[0].Page_4[0].PlantarL_2[0],F[0].Page_4[0].PlantarL_3[0],F[0].Page_4[0].PlantarL_4[0],F[0].Page_4[0].PlantarL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
          {
            main: "Ankle Dorsiflexion",
            sub: "",
            type: "check",
            defaultVal: "5",
            dbqName:
              "F[0].Page_4[0].AnkleL_0[0],F[0].Page_4[0].AnkleL_1[0],F[0].Page_4[0].AnkleL_2[0],F[0].Page_4[0].AnkleL_3[0],F[0].Page_4[0].AnkleL_4[0],F[0].Page_4[0].AnkleL_5[0]",
            values: ["0", "1", "2", "3", "4", "5"],
            answer: "5",
          },
        ],
      },
    ],
    rules: [
      {
        label: "Muscle Strength-Rate Scale",
        legend: "muscleStrengthScale",
        title: ".",
        subMain: "",
        sub: "",
        options: [
          {
            main: "No Muscle Movement",
            sub: "0/5",
          },
          {
            main: "Visible Muscle Contraction but No Joint Movement",
            sub: "1/5",
          },
          {
            main: "No movement against gravity",
            sub: "2/5",
          },
          {
            main: "No movement against resistance",
            sub: "3/5",
          },
          {
            main: "Less than normal strength",
            sub: "4/5",
          },
          {
            main: "Normal Strength",
            sub: "5/5",
          },
        ],
      },
    ],
  },
  {
    question:
      "Rate ##name##'s Deep Tendon Reflexes according to the following scale",
    sub: "",
    type: "select",
    show: true,
    section: {
      page: "5",
      title: "NEUROLOGIC EXAM",
      number: "4C",
    },
    questions: [
      {
        label: "Rate Reflexes",
        title: "Right Side",
        subMain: "Rate Strength",
        sub: "",
        options: [
          {
            main: "Biceps",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].BicepsR_0[0],F[0].Page_4[0].BicepsR_1[0],F[0].Page_4[0].BicepsR_2[0],F[0].Page_4[0].BicepsR_3[0],F[0].Page_4[0].BicepsR_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Triceps",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].TricepsR_0[0],F[0].Page_4[0].TricepsR_1[0],F[0].Page_4[0].TricepsR_2[0],F[0].Page_4[0].TricepsR_3[0],F[0].Page_4[0].TricepsR_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Brachioradialis",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].BrachR_0[0],F[0].Page_4[0].BrachR_1[0],F[0].Page_4[0].BrachR_2[0],F[0].Page_4[0].BrachR_3[0],F[0].Page_4[0].BrachR_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Knee",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].KneeR_0p[0],F[0].Page_4[0].KneeR_1plus[0],F[0].Page_4[0].KneeR_2plus[0],F[0].Page_4[0].KneeR_3plus[0],F[0].Page_4[0].KneeR_4plus[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Ankle",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].AnkleR_0p[0],F[0].Page_4[0].AnkleR_1plus[0],F[0].Page_4[0].AnkleR_2plus[0],F[0].Page_4[0].AnkleR_3plus[0],F[0].Page_4[0].AnkleR_4plus[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
        ],
      },
      {
        label: "Rate Reflexes",
        title: "Left Side",
        subMain: "Rate Strength",
        sub: "",
        options: [
          {
            main: "Biceps",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].BicepsL_0[0],F[0].Page_4[0].BicepsL_1[0],F[0].Page_4[0].BicepsL_2[0],F[0].Page_4[0].BicepsL_3[0],F[0].Page_4[0].BicepsL_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Triceps",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].TricepsL_0[0],F[0].Page_4[0].TricepsL_1[0],F[0].Page_4[0].TricepsL_2[0],F[0].Page_4[0].TricepsL_3[0],F[0].Page_4[0].TricepsL_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Brachioradialis",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].BrachL_0[0],F[0].Page_4[0].BrachL_1[0],F[0].Page_4[0].BrachL_2[0],F[0].Page_4[0].BrachL_3[0],F[0].Page_4[0].BrachL_4[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Knee",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].KneeL_0p[0],F[0].Page_4[0].KneeL_1plus[0],F[0].Page_4[0].KneeL_2plus[0],F[0].Page_4[0].KneeL_3plus[0],F[0].Page_4[0].KneeL_4plus[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
          {
            main: "Ankle",
            sub: "",
            type: "check",
            defaultVal: "2+",
            dbqName:
              "F[0].Page_4[0].AnkleL_0p[0],F[0].Page_4[0].AnkleL_1plus[0],F[0].Page_4[0].AnkleL_2plus[0],F[0].Page_4[0].AnkleL_3plus[0],F[0].Page_4[0].AnkleL_4plus[0]",
            values: ["0", "1+", "2+", "3+", "4+"],
            answer: "2+",
          },
        ],
      },
    ],
    rules: [
      {
        label: "Deep Tendon Reflex (DTR) Scale",
        legend: "reflexExamScale",
        options: [
          {
            main: "0",
            sub: "Absent",
          },
          {
            main: "1+",
            sub: "Decreased",
          },
          {
            main: "2+",
            sub: "Normal",
          },
          {
            main: "3+",
            sub: "Increased without clonus",
          },
          {
            main: "4+",
            sub: "Increased with clonus",
          },
        ],
      },
    ],
  },
  {
    question: "Sensation testing results",
    sub: "",
    type: "select",
    show: true,
    section: {
      page: "6",
      title: "NEUROLOGIC EXAM",
      number: "4D",
    },
    questions: [
      {
        label: "Flexion/Extension",
        title: "Right Side",
        subMain: "Severity",
        sub: "",
        options: [
          {
            main: "Shoulder area (C5)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal1[0],F[0].#subform[5].Decreased1[0],F[0].#subform[5].Absent1[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Inner/outer forearm (C6/T1)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal3[0],F[0].#subform[5].Decreased3[0],F[0].#subform[5].Absent3[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Hand/fingers (C6-8)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal5[0],F[0].#subform[5].Decreased5[0],F[0].#subform[5].Absent5[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thorax – Anterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal13a[0],F[0].#subform[5].Decreased13a[0],F[0].#subform[5].Absent13a[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thorax – Posterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal13c[0],F[0].#subform[5].Decreased13c[0],F[0].#subform[5].Absent13c[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Trunk – Anterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal14a[0],F[0].#subform[5].Decreased14a[0],F[0].#subform[5].Absent14a[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Trunk – Posterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal14c[0],F[0].#subform[5].Decreased14c[0],F[0].#subform[5].Absent14c[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thigh/knee (L3/4)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal7[0],F[0].#subform[5].Decreased7[0],F[0].#subform[5].Absent7[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Lower leg/ankle (L4/L5/S1)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal9[0],F[0].#subform[5].Decreased9[0],F[0].#subform[5].Absent9[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Foot/toes (L5)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal11[0],F[0].#subform[5].Decreased11[0],F[0].#subform[5].Absent11[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
        ],
      },
      {
        label: "Flexion/Extension",
        title: "Left Side",
        subMain: "Rate Strength",
        sub: "",
        options: [
          {
            main: "Shoulder area (C5)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal2[0],F[0].#subform[5].Decreased2[0],F[0].#subform[5].Absent2[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Inner/outer forearm (C6/T1)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal4[0],F[0].#subform[5].Decreased4[0],F[0].#subform[5].Absent4[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Hand/fingers (C6-8)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal6[0],F[0].#subform[5].Decreased6[0],F[0].#subform[5].Absent6[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thorax – Anterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal13b[0],F[0].#subform[5].Decreased13b[0],F[0].#subform[5].Absent13b[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thorax – Posterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal13d[0],F[0].#subform[5].Decreased13d[0],F[0].#subform[5].Absent13d[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Trunk – Anterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal14b[0],F[0].#subform[5].Decreased14b[0],F[0].#subform[5].Absent14b[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Trunk – Posterior",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal14d[0],F[0].#subform[5].Decreased14d[0],F[0].#subform[5].Absent14d[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Thigh/knee (L3/4)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal8[0],F[0].#subform[5].Decreased8[0],F[0].#subform[5].Absent8[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Lower leg/ankle (L4/L5/S1)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal10[0],F[0].#subform[5].Decreased10[0],F[0].#subform[5].Absent10[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
          {
            main: "Foot/toes (L5)",
            sub: "",
            type: "check",
            defaultVal: "Normal",
            dbqName:
              "F[0].#subform[5].Normal12[0],F[0].#subform[5].Decreased12[0],F[0].#subform[5].Absent12[0]",
            values: ["Normal", "Decreased", "Absent"],
            answer: "Normal",
          },
        ],
      },
    ],
  },
  {
    question: "Does ##name## have muscle atrophy attributable to MS?",
    sub: "",
    type: "radioModal",
    multi: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "6",
      title: "NEUROLOGIC EXAM",
      number: "4E",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].#subform[5].Yes19[0]",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].#subform[5].DescribeOther[1]",
        placeholder1: "If muscle atrophy is present, indicate location",
        text2: "",
        dbqName2: "F[0].#subform[5].Measurement[0]",
        placeholder2:
          "Provide difference measured in cm between normal and atrophied side, put N/A if unknown",
      },
      {
        main: "No",
        dbqName: "F[0].#subform[5].No19[0]",
        answer: "",
        showSubItems: false,
      },
    ],
  },

  {
    question:
      "Summary of ##name##'s muscle weakness in the upper and/or lower extremities attributable to MS?",
    sub: "",
    type: "radioModal",
    multi: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "6",
      title: "NEUROLOGIC EXAM",
      number: "4F",
    },
    questions: [
      {
        main: "Right Upper Extremity",
        dbqName: "pass_this_question",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "None",
            dbqName: "F[0].#subform[5].None1[0]",
            answer: "",
          },
          {
            main: "Mild",
            dbqName: "F[0].#subform[5].Mild1[0]",
            answer: "",
          },
          {
            main: "Moderate",
            dbqName: "F[0].#subform[5].Moderate1[0]",
            answer: "",
          },
          {
            main: "Severe",
            dbqName: "F[0].#subform[5].Severe1[0]",
            answer: "",
          },
          {
            main: "With Atrophy",
            dbqName: "F[0].#subform[5].WithAtrophy1[0]",
            answer: "",
          },
          {
            main: "Complete",
            dbqName: "F[0].#subform[5].Complete1[0]",
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate severity",
      },
      {
        main: "Left Upper Extremity",
        dbqName: "pass_this_question",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "None",
            dbqName: "F[0].#subform[5].None2[0]",
            answer: "",
          },
          {
            main: "Mild",
            dbqName: "F[0].#subform[5].Mild2[0]",
            answer: "",
          },
          {
            main: "Moderate",
            dbqName: "F[0].#subform[5].Moderate2[0]",
            answer: "",
          },
          {
            main: "Severe",
            dbqName: "F[0].#subform[5].Severe2[0]",
            answer: "",
          },
          {
            main: "With Atrophy",
            dbqName: "F[0].#subform[5].WithAtrophy2[0]",
            answer: "",
          },
          {
            main: "Complete",
            dbqName: "F[0].#subform[5].Complete2[0]",
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate severity",
      },
      {
        main: "Right Lower Extremity",
        dbqName: "pass_this_question",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "None",
            dbqName: "F[0].#subform[5].None3[0]",
            answer: "",
          },
          {
            main: "Mild",
            dbqName: "F[0].#subform[5].Mild3[0]",
            answer: "",
          },
          {
            main: "Moderate",
            dbqName: "F[0].#subform[5].Moderate3[0]",
            answer: "",
          },
          {
            main: "Severe",
            dbqName: "F[0].#subform[5].Severe3[0]",
            answer: "",
          },
          {
            main: "With Atrophy",
            dbqName: "F[0].#subform[5].WithAtrophy3[0]",
            answer: "",
          },
          {
            main: "Complete",
            dbqName: "F[0].#subform[5].Complete3[0]",
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate severity",
      },
      {
        main: "Left Lower Extremity",
        dbqName: "pass_this_question",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "None",
            dbqName: "F[0].#subform[5].None4[0]",
            answer: "",
          },
          {
            main: "Mild",
            dbqName: "F[0].#subform[5].Mild4[0]",
            answer: "",
          },
          {
            main: "Moderate",
            dbqName: "F[0].#subform[5].Moderate4[0]",
            answer: "",
          },
          {
            main: "Severe",
            dbqName: "F[0].#subform[5].Severe4[0]",
            answer: "",
          },
          {
            main: "With Atrophy",
            dbqName: "F[0].#subform[5].WithAtrophy4[0]",
            answer: "",
          },
          {
            main: "Complete",
            dbqName: "F[0].#subform[5].Complete4[0]",
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Indicate severity",
      },
      {
        main: "None",
        dbqName:
          "F[0].#subform[5].None1[0],F[0].#subform[5].None2[0],F[0].#subform[5].None3[0],F[0].#subform[5].None4[0]",
        answer: "",
      },
    ],
  },

  {
    question:
      "Does ##name## have signs or symptoms of depression, cognitive impairment, dementia or any other mental health condition attributable to MS and/or its treatment?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title:
        "MENTAL HEALTH MANIFESTATIONS DUE TO MULTIPLE SCLEROSIS OR ITS TREATMENT",
      number: "6A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_5[0].Yes22[0]",
    dbqName_no: "F[0].Page_5[0].No22[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Briefly describe",
    textdbqName: "F[0].Page_5[0].Describe[2]",
    textanswer: "",
  },
  {
    question:
      "Does ##name##’s mental health disorder result in gross impairment of through process or communication?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title:
        "MENTAL HEALTH MANIFESTATIONS DUE TO MULTIPLE SCLEROSIS OR ITS TREATMENT",
      number: "6B",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_5[0].Yes23[0]",
    dbqName_no: "F[0].Page_5[0].No23[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Briefly describe",
    textdbqName: "F[0].Page_5[0].Describe[0]",
    textanswer: "",
  },

  {
    question:
      "Is ##name## substantially confined to their dwelling? (Or other skilled care facility)?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title: "HOUSEBOUND",
      number: "7A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_5[0].Yes24[0]",
    dbqName_no: "F[0].Page_5[0].No24[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Describe how often per day or week and under what circumstances the Veteran is able to leave the home or immediate premises",
    textdbqName: "F[0].Page_5[0].Describe[1]",
    textanswer: "",
  },
  {
    question:
      "Does ##name## have another disability besides MS that contributes to them being housebound?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title: "HOUSEBOUND",
      number: "7B",
    },
    presidence: "Yes",
    ref: 1,
    dbqName_yes: "F[0].Page_5[0].Yes25[0]",
    dbqName_no: "F[0].Page_5[0].No25[0]",
    answer: "",
  },
  {
    question:
      "History of recurrent symptomatic urinary tract infections attributable to MS",
    sub: "",
    type: "radioModal",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "HOUSEBOUND",
      number: "7B",
    },
    questions: [
      {
        main: "Condition #1",
        dbqName: "pass_this_question",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_5[0].Condition1[0]",
        placeholder1:
          "Please provide condition contributes to the veteran being housebound",
        text2: "",
        dbqName2: "F[0].Page_5[0].Description[0]",
        placeholder2: "Please provide the description of the condition",
      },
      {
        main: "Condition #2",
        dbqName: "pass_this_question",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_5[0].Condition2[0]",
        placeholder1:
          "Please provide condition contributes to the veteran being housebound",
        text2: "",
        dbqName2: "F[0].Page_5[0].Description[1]",
        placeholder2: "Please provide the description of the condition",
      },
      {
        main: "Condition #3",
        dbqName: "pass_this_question",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_5[0].Condition3[0]",
        placeholder1:
          "Please provide condition contributes to the veteran being housebound",
        text2: "",
        dbqName2: "F[0].Page_5[0].Description[2]",
        placeholder2: "Please provide the description of the condition",
      },
    ],
  },

  {
    question: "Can ##name## dress and undress without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,

    section: {
      page: "7",
      title: "AID AND ATTENDANCE",
      number: "8A",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_5[0].Yes26[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_5[0].No26[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_5[0].Yes27[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_5[0].No27[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question:
      "Does ##name## have sufficient upper extremity strength and coordination to feed themselves without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "AID AND ATTENDANCE",
      number: "8B",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_5[0].Yes28[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_5[0].No28[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_5[0].Yes29[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_5[0].No29[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question: "Can ##name## prepare meals without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8C",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes30[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No30[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes31[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No31[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question: "Can ##name## perform toileting without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8D",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes32[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No32[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes33[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No33[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question: "Can ##name## bathe themselves without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8E",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes34[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No34[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes35[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No35[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question:
      "Can ##name## keep themselves clean and presentable without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8F",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes36[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No36[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes37[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No37[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question:
      "Is ##name## able to take prescribed medication in a timely manner and with accurate dosage without assistance?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8G",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes38[0]",
        answer: "",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No38[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes39[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No39[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
    ],
  },
  {
    question:
      "Does ##name## require assistance with any special prosthetic or orthopedic appliance?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8H",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_6[0].Yes40[0]",
    dbqName_no: "F[0].Page_6[0].No40[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please describe impact of the Veteran's Multiple Sclerosis, providing one or more examples",
    textdbqName: "F[0].Page_6[0].Describe[0]",
    textanswer: "",
  },
  {
    question: "Is ##name## bedridden? ",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8I",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes41[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes42[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No42[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No41[0]",
        answer: "",
      },
    ],
  },
  {
    question: "Is ##name## legally blind?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8J",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes43[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_6[0].RightEye[0]",
        placeholder1:
          "Provide best corrected vision of Right Eye, put N/A if unknown",
        text2: "",
        dbqName2: "F[0].Page_6[0].LeftEye[0]",
        placeholder2:
          "Provide best corrected vision of Left Eye, put N/A if unknown",
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes44[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No44[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No43[0]",
        answer: "",
        showSubItems: false,
        text1: "",
        dbqName1: "F[0].Page_6[0].RightEye[0]",
        placeholder1:
          "Provide best corrected vision of Right Eye, put N/A if unknown",
        text2: "",
        dbqName2: "F[0].Page_6[0].LeftEye[0]",
        placeholder2:
          "Provide best corrected vision of Left Eye, put N/A if unknown",
      },
    ],
  },
  {
    question:
      "Does ##name## require care and/or assistance on a regular basis due to his or her physical and/or mental disabilities in Order to protect him or herself from the hazards and/or dangers incident to his or her daily environment?",
    sub: "",
    type: "radioModal",
    multi: false,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "AID AND ATTENDANCE",
      number: "8K",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "F[0].Page_6[0].Yes45[0]",
        answer: "",
        multi: false,
        showSubItems: false,
        subItems: [
          {
            main: "Yes",
            dbqName: "F[0].Page_6[0].Yes46[0]",
            colWidth: 6,
            answer: "",
          },
          {
            main: "No",
            dbqName: "F[0].Page_6[0].No46[0]",
            colWidth: 6,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel:
          "Is this limitation caused by the Veteran's Multiple Sclerosis?",
      },
      {
        main: "No",
        dbqName: "F[0].Page_6[0].No45[0]",
        answer: "",
      },
    ],
  },

  {
    question: "Does ##name## require a more skilled level of Aid (A&A)?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "8",
      title: "NEED FOR HIGHER LEVEL",
      number: "9",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_6[0].Yes47[0]",
    dbqName_no: "F[0].Page_6[0].No47[0]",
    answer: "",
  },

  {
    question:
      "Does ##name##'s multiple sclerosis impact his or her ability to work?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "10",
      title: "FUNCTIONAL IMPACT",
      number: "14",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "F[0].Page_9[0].Yes56[0]",
    dbqName_no: "F[0].Page_9[0].No56[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please describe impact of the Veteran's Multiple Sclerosis, providing one or more examples",
    textdbqName: "F[0].Page_9[0].Describe[0]",
    textanswer: "",
  },

  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    maxLength: 1250,
    show: true,
    section: {
      page: "10",
      title: "REMARKS",
      number: "15",
    },
    options: [],
    dbqName: "F[0].Page_9[0].Remarks[0]",
    answer: "",
  },
];

export default msdbq_questions;
